import type { JSX } from "react";
import type { NavItemProps } from "./nav-item/nav-item";
import type { ClassNameProp } from "@charterindex/armoury-www";
import { SingleNavItem } from "./nav-item/nav-item";


export type NavMenuInlineProps = ClassNameProp & {
	items: readonly NavItemProps[];
};
export const NavMenuInline = (p: NavMenuInlineProps): JSX.Element => (
	<div className={ p.className }>
		{ p.items.map(i => (
			<SingleNavItem { ...i } key={ i.labelKey } slim/>
	)) }
	</div>
);
